import { useEffect } from "react";

function GoogleTranslate() {
  useEffect(() => {
  const loadTranslate = () => {
    if (window.google && window.google.translate) {
      new window.google.translate.TranslateElement(
        {
          pageLanguage: "en",
          layout:
            window.google.translate.TranslateElement.InlineLayout.SIMPLE,
        },
        "google_translate_element"
      );
    }
  };

  const timer = setTimeout(() => {
    const script = document.createElement("script");

    script.src =
      "https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";

    script.async = true;
    script.defer = true;

    window.googleTranslateElementInit = loadTranslate;

    document.body.appendChild(script);
  }, 9000);

  return () => clearTimeout(timer);
}, []);

  return <div id="google_translate_element"></div>;
}

export default GoogleTranslate;